import type { SCondition } from '@nestjsx/crud-request';

export interface TableColumn {
  label: string;
  field: string;
  sortable?: boolean; // defaults to true
}

export enum SORT_ORDER {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface GetTableDataOptions {
  fields: string[];
  sortColumn: string;
  sortOrder: SORT_ORDER;
  page: number;
}

export interface FetchCrudData {
  sort?: string[];
  s?: SCondition | string;
  offset?: number;
  limit?: number;
}
